<template>
    <div class="stock-tickers-bar">
        <StockTicker 
            label="BVB"
            source="bvb"
            :animation-duration="30"
        />
        <StockTicker 
            label="CRYPTO"
            source="crypto"
            :animation-duration="20"
        />
        <StockTicker 
            label="INTERNATIONAL"
            source="international"
            :animation-duration="40"
        />
    </div>
</template>

<script>
import StockTicker from './StockTicker.vue'

export default {
    components: { StockTicker }
}
</script>

<style scoped>
.stock-tickers-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 50;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(8px);
    border-top: 1px solid #e5e7eb;
    display: flex;
    flex-direction: column;
}

@media (max-width: 1023px) {
    .stock-tickers-bar {
        display: none;
    }
}

.dark .stock-tickers-bar {
    background: rgba(15, 23, 42, 0.95);
    border-top-color: #334155;
}
</style>

